import {
  initTable,
  formatNameHeaderColumn,
  addPointInteger,
  downloadPDFTable,
  downloadCSVTable,
  initContractAllGroups,
  initExpandAllGroups,
} from 'vlcishared';
import { DEFAULT_LANGUAGE } from '../common-language';
import { TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL } from './texts';

const UNIDAD_ADMIN = 'unidad';
const TIPO = 'tipo';
const TAREAS_REALIZADAS = 'total_tareas_realizadas';
const TAREAS_PENDIENTES = 'total_tareas_pendientes';
const CARGA_ADMIN = 'carga_administrativa';
const NOMBRE_FICHERO = 'Tareas por Tipo';

const commonObjectMetric = {
  titleFormatter: (cell) => formatNameHeaderColumn(cell, 20),
  headerSort: false,
  sorter: 'string',
  width: '20%',
  hozAlign: 'center',
  headerHozAlign: 'center',
  formatter: function formatDecimal(cell) {
    return addPointInteger(cell.getValue());
  },
};

const cargaAdministrativa = function (values, data) {
  let sumaPendientes = 0;
  let sumaRealizadas = 0;

  data.forEach((row) => {
    const pendientes = parseFloat(row.total_tareas_pendientes) || 0;
    const realizadas = parseFloat(row.total_tareas_realizadas) || 0;

    sumaPendientes += pendientes;
    sumaRealizadas += realizadas;
  });

  if (sumaRealizadas === 0) {
    return 0;
  }
  return (sumaPendientes / sumaRealizadas).toFixed(2).replace('.', ',');
};

const columnasTabla = [
  {
    title: TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
      'unidad_administrativa',
    ),
    field: UNIDAD_ADMIN,
    width: '40%',
    hozAlign: 'center',
    headerHozAlign: 'center',
    frozen: true,
    headerSort: false,
  },
  {
    title:
      TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
        'tareas_realizadas',
      ),
    field: TAREAS_REALIZADAS,
    topCalc: 'sum',
    topCalcFormatter: function formatDecimal(cell) {
      return addPointInteger(cell.getValue());
    },
    ...commonObjectMetric,
  },
  {
    title:
      TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
        'tareas_pendientes',
      ),
    field: TAREAS_PENDIENTES,
    topCalc: 'sum',
    topCalcFormatter: function formatDecimal(cell) {
      return addPointInteger(cell.getValue());
    },
    ...commonObjectMetric,
  },
  {
    title: TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
      'carga_administrativa',
    ),
    field: CARGA_ADMIN,
    topCalc: cargaAdministrativa,
    topCalcOnData: true,
    ...commonObjectMetric,
  },
];

export async function echartTablaTareasPorTipo(datos) {
  const dataObj = datos.resultset.map((item) => ({
    [TIPO]: item[0],
    [UNIDAD_ADMIN]: item[1],
    [TAREAS_REALIZADAS]: item[2],
    [TAREAS_PENDIENTES]: item[3],
    [CARGA_ADMIN]: item[4],
  }));
  const option = {
    height: '100%',
    scrollable: true,
    layout: 'fitDataTable',
    groupBy: TIPO,
    columnCalcs: 'both',
    groupClosedShowCalcs: true,
    groupToggleElement: 'header',
    columns: columnasTabla,
    data: dataObj,
  };

  const table = await initTable('tablaTipo', option);
  table.setGroupHeader((value) => `${value}`);

  downloadCSVTable(table, NOMBRE_FICHERO, 'download-csv_Tipo');
  downloadPDFTable(table, NOMBRE_FICHERO, 'download-pdf_Tipo');

  initExpandAllGroups(table, dataObj, 'expandAll');
  initContractAllGroups(table, dataObj, 'contractAll');
}
